const chatModule = {
    actions: {
        toggleSwipe:'chat/actions/toggleSwipe',
        sendTypeEvent : 'chat/actions/sendTypeEvent',
        conversations: {
            loadGroup: 'chat/actions/conversations/loadGroup',
            clearGroup: 'chat/actions/conversations/clearGroup',

            push: 'chat/actions/conversations/push',
            unshift: 'chat/actions/conversations/unshift',

            update: 'chat/actions/conversations/update',
            updateConversationEvent: 'chat/actions/conversations/updateConversationEvent',

            markAsRead: 'chat/actions/conversations/markAsRead',
            remove: 'chat/actions/conversations/remove',
            removeAllUserBlockedChats: 'chat/actions/conversations/removeAllUserBlockedChats',
            pushUnblockedConversations: 'chat/actions/conversations/pushUnblockedConversations'
        },
        messages: {
            load: 'chat/actions/messages/load',
            loadEvent: 'chat/actions/messages/loadEvent',
            loadGroup: 'chat/actions/messages/loadGroup',
            delete: 'chat/actions/messages/delete',
            addEmoji: 'chat/actions/messages/addEmoji',
            deleteEmoji: 'chat/actions/messages/deleteEmoji'
        },
    },
    mutations: {
        reset: 'chat/mutations/reset',
        modal: 'chat/mutations/modal',
        toggleSwipe:'chat/mutations/toggleSwipe',
        general: {
          setUnreadConversationsIds: 'chat/mutations/general/setUnreadConversationsIds'
        },
        setLastTypeEventTime : 'chat/mutations/setLastTypeEventTime',
        conversations: {
            deleteCursor: 'chat/mutations/conversations/deleteCursor',
            setCursor: 'chat/mutations/conversations/setCursor',
            afterUpdate: 'chat/mutations/conversations/afterUpdate',

            addLoadingChat: 'chat/mutations/conversations/addLoadingChat',
            removeLoadingChat: 'chat/mutations/conversations/removeLoadingChat',

            clearGroup: 'chat/mutations/conversations/clearGroup',
            sortGroup: 'chat/mutations/conversations/sortGroup',

            push: 'chat/mutations/conversations/push',
            unshift: 'chat/mutations/conversations/unshift',

            update: 'chat/mutations/conversations/update',
            updateConversationEvent: 'chat/mutations/conversations/updateConversationEvent',

            markAsRead: 'chat/mutations/conversations/markAsRead',
            remove: 'chat/mutations/conversations/remove',
            removeAllUserBlockedChats: 'chat/mutations/conversations/removeAllUserBlockedChats',
            pushUnblockedConversations: 'chat/mutations/conversations/pushUnblockedConversations',

            clearHiddenChats: 'chat/mutations/conversations/clearHiddenChats',
            hide: 'chat/mutations/conversations/hide',

            addTyping: 'chat/mutations/conversations/addTyping'
        },
        messages: {
            unshift: 'chat/mutations/messages/unshift',
            set: 'chat/mutations/messages/set',

            setImages: 'chat/mutations/messages/setImages',
            setVideos: 'chat/mutations/messages/setVideos',
            setImagesEvent: 'chat/mutations/messages/setImagesEvent',
            setVideosEvent: 'chat/mutations/messages/setVideosEvent',

            deleteImages: 'chat/mutations/messages/deleteImages',
            deleteVideos: 'chat/mutations/messages/deleteVideos',

            checkMessage: 'chat/mutations/messages/checkMessage'
        },
        replies: {
          add: 'chat/mutations/replies/add',
          remove: 'chat/mutations/replies/remove',
        },
        message: {
            push: 'chat/mutations/message/push',
            update: 'chat/mutations/message/update',
            addEmoji: 'chat/mutations/message/addEmoji',
            deleteEmoji: 'chat/mutations/message/deleteEmoji'
        },
    },
    getters: {
        general: {
            unreadConversationsIds: 'chat/getters/general/unreadConversationsIds'
        },
        lastTypeEvent: 'chat/getters/lastTypeEvent',
        conversations: {
            cursor: 'chat/getters/conversations/cursor',
            all: 'chat/getters/conversations/all',
            unread: 'chat/getters/conversations/unread',
            favorites: 'chat/getters/conversations/favorites',
            chats: 'chat/getters/conversations/chats',
            clubs: 'chat/getters/conversations/clubs',
            userIds: 'chat/getters/conversations/userIds',
            loadingChats: 'chat/getters/conversations/loadingChats'
        },
        replies: {
            get: 'chat/getters/replies/get',
        },
        messages: {
            count: {
                unread: 'chat/getters/messages/count/unread',
                unreadEvent: 'chat/getters/messages/count/unreadEvent',
            }
        }
    }
}

export default chatModule
